/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare
import { Skeleton, Text } from '@mantine/core';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useModals } from '@mantine/modals';
import { useParams } from 'react-router-dom';
import { fetchDocumentsByEvent } from '../../../Service/restapi/documentService';
import { EventParticipationsContext } from '../../../Service/Context/EventParticipationContextV2';
import PanePaper from '../../PanePaper';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import { TestS } from '../../../TestS';
import BookitupTutorialIcon from '../../../Atoms/BookitupTutorialIcon';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import CreateDocumentModal from './CreateDocumentModal';
import DocumentPaneTable from './DocumentPaneTable';

const DOCUMENT_TYPES = ['OFFER', 'CONFIRMATION', 'PARTIAL_INVOICE', 'INVOICE', 'REMINDER', 'CREDIT_NOTE', 'CANCEL'];

const DocumentPane = () => {
  const { id: eventId } = useParams();
  const { openLicenceModal } = useContext(ViolationContext);
  const eventParticipantsContext = useContext(EventParticipationsContext);
  const { customer } = eventParticipantsContext;
  const [isLoading, setLoading] = useState(false);
  const [documents, setDocuments] = useState();
  const { interceptViolation } = useContext(ViolationContext);
  const { openModal } = useModals();
  const { id: customerId } = customer ?? {};

  const documentsByType = useMemo(() => {
    if (!documents) return undefined;

    const groupedDocuments = {};
    DOCUMENT_TYPES.forEach((documentType) => {
      const matchingDocuments = documents.filter((document) => document.documentType === documentType);
      if (matchingDocuments.length > 0) groupedDocuments[documentType] = matchingDocuments;
    });
    return groupedDocuments;
  }, [documents]);

  const fetchDocuments = useCallback(async () => {
    setLoading(true);
    setDocuments(undefined);

    try {
      const response = await fetchDocumentsByEvent(eventId);
      if (response.ok) {
        setDocuments(await response.json());
      } else {
        console.error(`could not load documents of event ${eventId}`);
      }
    } catch (error) {
      console.error(`could not load documents of event ${eventId}`);
      console.error({ error });
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  const openCreateDocumentModal = () => {
    openModal({
      size: 'sm',
      title: (
        <Text weight="bolder" size="xl" sx={{ lineHeight: 1.2 }}>
          Vorlage wählen
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      children: (
        <CreateDocumentModal
          initialCustomerId={customerId}
          eventId={eventId}
          eventParticipationContext={eventParticipantsContext}
          openLicenceModal={openLicenceModal}
          interceptViolation={interceptViolation}
        />
      ),
    });
  };

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return (
    <PanePaper
      title="common.documents"
      tooltip="help.event.documents.pane"
      rightSection={
        <>
          <BookitupTutorialIcon
            videoUrl={'https://app.bookitup.de/academy/channels/offer-service?episodeId=tfl5yj1fg2'}
            name={'CreateDocument'}
          />
          <BookitupAddIcon onClick={openCreateDocumentModal} testId={TestS.Documents.CREATE_DOCUMENT} />
        </>
      }
    >
      <div>
        {isLoading ? (
          <div>
            {Array.from(Array(3)).map(() => (
              <Skeleton key={Math.random()} radius="md" height={25} width="100%" mb={10} />
            ))}
          </div>
        ) : (
          <div>
            {!documents || !documentsByType || documents.length === 0 ? (
              <Text italic color="dimmed" size="xs" weight="lighter">
                Noch nichts hinzugefügt.
              </Text>
            ) : (
              <DocumentPaneTable documentsByType={documentsByType} reload={fetchDocuments} />
            )}
          </div>
        )}
      </div>
    </PanePaper>
  );
};

export default DocumentPane;
